
import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import PrefetchLink from '@/components/routing/PrefetchLink';

interface NavItemProps {
  to: string;
  icon: LucideIcon;
  children: React.ReactNode;
  isActive?: boolean;
  isCompact?: boolean;
}

const NavItem = ({
  to,
  icon: Icon,
  children,
  isActive = false,
  isCompact = false
}: NavItemProps) => {
  
  const renderContent = () => (
    <PrefetchLink
      to={to}
      prefetch="hover"
      prefetchDelay={100}
      className={cn(
        "flex items-center gap-2 p-2 rounded-md text-sm font-medium transition-colors w-full",
        isActive
          ? "bg-primary/10 text-primary hover:bg-primary/20"
          : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
      )}
    >
      <Icon className="h-4 w-4" />
      {!isCompact && <span>{children}</span>}
    </PrefetchLink>
  );

  // If compact, wrap in tooltip
  if (isCompact) {
    return (
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            {renderContent()}
          </TooltipTrigger>
          <TooltipContent side="right" sideOffset={10}>
            <p>{children}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return renderContent();
};

export default NavItem;
